import React from "react";
import './Vorteile.css';

const Vorteile = () => {
    const vorteile = [
      "Wir sind rund um die Uhr für Sie erreichbar, damit Ihre Projekte ohne Verzögerung umgesetzt werden.",
      "Profitieren Sie von unseren frischen Ideen und modernen Lösungsansätzen als junges Unternehmen.",
      "Unsere Dienstleistungen erfolgen mit modernstem Equipment für beste Ergebnisse.",
      "Unsere umweltfreundlichen Verfahren sorgen für eine nachhaltige Zukunft.",
    ];


  
    return (
      <section className="vorteile-section">
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Warum Sie sich für uns entscheiden sollten</h2>
        <div className="vorteile-div">
          <ul className="vorteile-list">
            {vorteile.map((vorteil, index) => (
              <li 
                key={index} 
                style={{ 
                  marginBottom: '20px', 
                  padding: '15px', 
                  border: '1px solid #ddd', 
                  borderRadius: '8px', 
                  backgroundColor: '#fff', 
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  textAlign: 'center'
                }}
              >
                {vorteil}
              </li>
            ))}
          </ul>
          <img src = {require("../assets/images/vorteile-image.jpg")}></img>
        </div>
      </section>
    );
  };
  
  export default Vorteile;
  
  